export default __webpack_public_path__ + "static/SRI 1085 - Product Specifications & Technical Data-45b3e03e00be02cec4e3fc654b38a44d.pdf";